import { usePdfTextExtraction } from "@/Utils/usePdfTextExtraction";

/**
 * Pages of the open document matching the search term, plus extraction
 * progress for the toolbar.
 *
 * Takes the PDFDocumentProxy the viewer's <Document> already resolved rather
 * than a URL, so searching reuses that transport instead of opening a second
 * download of the same file. Text is extracted only once the user has typed
 * something — walking every page on open forced whole documents down the wire.
 *
 * @param {import("pdfjs-dist").PDFDocumentProxy|null} pdfDoc
 * @param {string} searchTerm
 */
export const usePdfSearch = (pdfDoc, searchTerm) => usePdfTextExtraction(pdfDoc, searchTerm);
